export function removeClassName(elmRef, removeClass) {
    var elm = elmRef.current;
    if (!elm)
        return;
    if (elm.className.includes(removeClass)) {
        elm.className = cleanClass(elm, removeClass);
    }
    var icons = elm.querySelectorAll("." + removeClass);
    if ((icons === null || icons === void 0 ? void 0 : icons.length) > 0) {
        icons.forEach(function (x) { return (x.className = cleanClass(x, removeClass)); });
    }
}
function cleanClass(elm, removeClass) {
    return elm.className.replace(removeClass, '').trim();
}
